var map = {
	"./877-hangry.png": 71317,
	"./abomasnow-mega.png": 47607,
	"./abomasnow.png": 20176,
	"./abra.png": 45173,
	"./absol-mega.png": 12280,
	"./absol.png": 41107,
	"./accelgor.png": 5562,
	"./aegislash-blade.png": 98076,
	"./aegislash-shield.png": 31623,
	"./aerodactyl-mega.png": 64807,
	"./aerodactyl.png": 97377,
	"./aggron-mega.png": 70401,
	"./aggron.png": 42638,
	"./aipom.png": 18002,
	"./alakazam-mega.png": 79486,
	"./alakazam.png": 33547,
	"./alcremie-gmax.png": 82541,
	"./alcremie.png": 25826,
	"./alomomola.png": 61883,
	"./altaria-mega.png": 58472,
	"./altaria.png": 76152,
	"./amaura.png": 20257,
	"./ambipom.png": 61845,
	"./amoonguss.png": 20206,
	"./ampharos-mega.png": 30977,
	"./ampharos.png": 25385,
	"./annihilape.png": 95535,
	"./anorith.png": 32848,
	"./appletun-gmax.png": 54496,
	"./appletun.png": 81282,
	"./applin.png": 52902,
	"./araquanid-totem.png": 24967,
	"./araquanid.png": 84200,
	"./arbok.png": 22090,
	"./arboliva.png": 88024,
	"./arcanine-hisui.png": 18306,
	"./arcanine.png": 34613,
	"./arceus.png": 62379,
	"./archen.png": 94167,
	"./archeops.png": 73553,
	"./arctibax.png": 24635,
	"./arctovish.png": 78025,
	"./arctozolt.png": 20138,
	"./ariados.png": 81329,
	"./armaldo.png": 91345,
	"./armarouge.png": 66164,
	"./aromatisse.png": 49524,
	"./aron.png": 51907,
	"./arrokuda.png": 8415,
	"./articuno-galar.png": 28761,
	"./articuno.png": 86368,
	"./audino-mega.png": 44016,
	"./audino.png": 3965,
	"./aurorus.png": 8452,
	"./avalugg-hisui.png": 63893,
	"./avalugg.png": 65760,
	"./axew.png": 77452,
	"./azelf.png": 6137,
	"./azumarill.png": 25610,
	"./azurill.png": 57488,
	"./bagon.png": 36064,
	"./baltoy.png": 13593,
	"./banette-mega.png": 7231,
	"./banette.png": 82699,
	"./barbaracle.png": 17716,
	"./barboach.png": 33653,
	"./barraskewda.png": 10700,
	"./basculegion-female.png": 49130,
	"./basculegion-male.png": 49088,
	"./basculin-blue-striped.png": 14899,
	"./basculin-red-striped.png": 39130,
	"./basculin-white-striped.png": 55436,
	"./bastiodon.png": 41857,
	"./baxcalibur.png": 17916,
	"./bayleef.png": 60833,
	"./beartic.png": 14584,
	"./beautifly.png": 48286,
	"./beedrill-mega.png": 9875,
	"./beedrill.png": 49599,
	"./beheeyem.png": 88388,
	"./beldum.png": 24063,
	"./bellibolt.png": 3160,
	"./bellossom.png": 42772,
	"./bellsprout.png": 11300,
	"./bergmite.png": 53197,
	"./bewear.png": 64268,
	"./bibarel.png": 38121,
	"./bidoof.png": 13309,
	"./binacle.png": 90352,
	"./bisharp.png": 30022,
	"./blacephalon.png": 83070,
	"./blastoise-gmax.png": 33774,
	"./blastoise-mega.png": 18837,
	"./blastoise.png": 35873,
	"./blaziken-mega.png": 75430,
	"./blaziken.png": 59406,
	"./blipbug.png": 44104,
	"./blissey.png": 99138,
	"./blitzle.png": 98124,
	"./boldore.png": 5334,
	"./boltund.png": 74341,
	"./bombirdier.png": 75670,
	"./bonsly.png": 35580,
	"./bouffalant.png": 31179,
	"./bounsweet.png": 25541,
	"./braixen.png": 61353,
	"./brambleghast.png": 75216,
	"./bramblin.png": 42457,
	"./braviary-hisui.png": 34829,
	"./braviary.png": 40245,
	"./breloom.png": 29481,
	"./brionne.png": 47474,
	"./bronzong.png": 84075,
	"./bronzor.png": 35127,
	"./brute-bonnet.png": 6798,
	"./bruxish.png": 1925,
	"./budew.png": 2020,
	"./buizel.png": 11488,
	"./bulbasaur.png": 26182,
	"./buneary.png": 59246,
	"./bunnelby.png": 44977,
	"./burmy.png": 57750,
	"./butterfree-gmax.png": 93467,
	"./butterfree.png": 48288,
	"./buzzwole.png": 45083,
	"./cacnea.png": 94043,
	"./cacturne.png": 42170,
	"./calyrex-ice.png": 12685,
	"./calyrex-shadow.png": 57547,
	"./calyrex.png": 96222,
	"./camerupt-mega.png": 62463,
	"./camerupt.png": 72199,
	"./capsakid.png": 53705,
	"./carbink.png": 17858,
	"./carkol.png": 53875,
	"./carnivine.png": 89936,
	"./carracosta.png": 4122,
	"./carvanha.png": 63198,
	"./cascoon.png": 55104,
	"./castform-rainy.png": 10872,
	"./castform-snowy.png": 71668,
	"./castform-sunny.png": 47055,
	"./castform.png": 7711,
	"./caterpie.png": 87650,
	"./celebi.png": 54856,
	"./celesteela.png": 85027,
	"./centiskorch-gmax.png": 3274,
	"./centiskorch.png": 44520,
	"./ceruledge.png": 77408,
	"./cetitan.png": 45901,
	"./cetoddle.png": 35043,
	"./chandelure.png": 6168,
	"./chansey.png": 2950,
	"./charcadet.png": 25288,
	"./charizard-gmax.png": 2357,
	"./charizard-mega-x.png": 82480,
	"./charizard-mega-y.png": 94064,
	"./charizard.png": 70303,
	"./charjabug.png": 64197,
	"./charmander.png": 89156,
	"./charmeleon.png": 56877,
	"./chatot.png": 9767,
	"./cherrim.png": 57282,
	"./cherubi.png": 4149,
	"./chesnaught.png": 6335,
	"./chespin.png": 2807,
	"./chewtle.png": 4121,
	"./chi-yu.png": 3999,
	"./chien-pao.png": 17872,
	"./chikorita.png": 53503,
	"./chimchar.png": 68906,
	"./chimecho.png": 52638,
	"./chinchou.png": 33140,
	"./chingling.png": 17532,
	"./cinccino.png": 49876,
	"./cinderace-gmax.png": 36794,
	"./cinderace.png": 71279,
	"./clamperl.png": 95489,
	"./clauncher.png": 57249,
	"./clawitzer.png": 26771,
	"./claydol.png": 19107,
	"./clefable.png": 36492,
	"./clefairy.png": 65932,
	"./cleffa.png": 29910,
	"./clobbopus.png": 65878,
	"./clodsire.png": 81375,
	"./cloyster.png": 15529,
	"./coalossal-gmax.png": 8960,
	"./coalossal.png": 80608,
	"./cobalion.png": 21474,
	"./cofagrigus.png": 62707,
	"./combee.png": 31977,
	"./combusken.png": 22693,
	"./comfey.png": 63124,
	"./conkeldurr.png": 61151,
	"./copperajah-gmax.png": 5256,
	"./copperajah.png": 20776,
	"./corphish.png": 12734,
	"./corsola-galar.png": 89984,
	"./corsola.png": 75595,
	"./corviknight-gmax.png": 83414,
	"./corviknight.png": 61662,
	"./corvisquire.png": 78329,
	"./cosmoem.png": 33448,
	"./cosmog.png": 87117,
	"./cottonee.png": 31993,
	"./crabominable.png": 43809,
	"./crabrawler.png": 26067,
	"./cradily.png": 37834,
	"./cramorant-gorging.png": 48153,
	"./cramorant-gulping.png": 45997,
	"./cramorant.png": 30530,
	"./cranidos.png": 35394,
	"./crawdaunt.png": 71637,
	"./cresselia.png": 1549,
	"./croagunk.png": 48170,
	"./crobat.png": 63252,
	"./crocalor.png": 844,
	"./croconaw.png": 67580,
	"./crustle.png": 62141,
	"./cryogonal.png": 8203,
	"./cubchoo.png": 70253,
	"./cubone.png": 72569,
	"./cufant.png": 44723,
	"./cursola.png": 2806,
	"./cutiefly.png": 32628,
	"./cyclizar.png": 84443,
	"./cyndaquil.png": 78120,
	"./dachsbun.png": 98140,
	"./darkrai.png": 25761,
	"./darmanitan-galar-standard.png": 45116,
	"./darmanitan-galar-zen.png": 60270,
	"./darmanitan-standard.png": 60718,
	"./darmanitan-zen.png": 34644,
	"./dartrix.png": 71611,
	"./darumaka-galar.png": 49535,
	"./darumaka.png": 25608,
	"./decidueye-hisui.png": 59262,
	"./decidueye.png": 54697,
	"./dedenne.png": 97970,
	"./deerling.png": 32983,
	"./deino.png": 91378,
	"./delcatty.png": 34263,
	"./delibird.png": 60877,
	"./delphox.png": 89439,
	"./deoxys-attack.png": 1673,
	"./deoxys-defense.png": 94399,
	"./deoxys-normal.png": 57995,
	"./deoxys-speed.png": 49371,
	"./dewgong.png": 57801,
	"./dewott.png": 95761,
	"./dewpider.png": 49595,
	"./dhelmise.png": 34198,
	"./dialga-origin.png": 82564,
	"./dialga.png": 73765,
	"./diancie-mega.png": 73203,
	"./diancie.png": 45385,
	"./diggersby.png": 11689,
	"./diglett-alola.png": 71013,
	"./diglett.png": 87365,
	"./ditto.png": 66654,
	"./dodrio.png": 62805,
	"./doduo.png": 39512,
	"./dolliv.png": 43356,
	"./dondozo.png": 4401,
	"./donphan.png": 76395,
	"./dottler.png": 63389,
	"./doublade.png": 59359,
	"./dracovish.png": 2646,
	"./dracozolt.png": 22037,
	"./dragalge.png": 35469,
	"./dragapult.png": 21888,
	"./dragonair.png": 17103,
	"./dragonite.png": 42464,
	"./drakloak.png": 3760,
	"./drampa.png": 96792,
	"./drapion.png": 64349,
	"./dratini.png": 62259,
	"./drednaw-gmax.png": 84076,
	"./drednaw.png": 39269,
	"./dreepy.png": 40170,
	"./drifblim.png": 94921,
	"./drifloon.png": 55895,
	"./drilbur.png": 3367,
	"./drizzile.png": 17096,
	"./drowzee.png": 25348,
	"./druddigon.png": 53199,
	"./dubwool.png": 913,
	"./ducklett.png": 79378,
	"./dudunsparce-three-segment.png": 60862,
	"./dudunsparce.png": 45560,
	"./dugtrio-alola.png": 5449,
	"./dugtrio.png": 5668,
	"./dunsparce.png": 34353,
	"./duosion.png": 12722,
	"./duraludon-gmax.png": 82653,
	"./duraludon.png": 37169,
	"./durant.png": 93806,
	"./dusclops.png": 65991,
	"./dusknoir.png": 83899,
	"./duskull.png": 42245,
	"./dustox.png": 32342,
	"./dwebble.png": 24221,
	"./eelektrik.png": 93609,
	"./eelektross.png": 47033,
	"./eevee-gmax.png": 86472,
	"./eevee-starter.png": 93834,
	"./eevee.png": 16543,
	"./eiscue-ice.png": 73145,
	"./eiscue-noice.png": 3015,
	"./ekans.png": 66083,
	"./eldegoss.png": 48605,
	"./electabuzz.png": 424,
	"./electivire.png": 64710,
	"./electrike.png": 59367,
	"./electrode-hisui.png": 31306,
	"./electrode.png": 31466,
	"./elekid.png": 20651,
	"./elgyem.png": 66721,
	"./emboar.png": 53333,
	"./emolga.png": 98120,
	"./empoleon.png": 32760,
	"./enamorus-incarnate.png": 51680,
	"./enamorus-therian.png": 41757,
	"./entei.png": 63085,
	"./escavalier.png": 59017,
	"./espathra.png": 59074,
	"./espeon.png": 1048,
	"./espurr.png": 20902,
	"./eternatus-eternamax.png": 40244,
	"./eternatus.png": 24367,
	"./excadrill.png": 94096,
	"./exeggcute.png": 39834,
	"./exeggutor-alola.png": 82458,
	"./exeggutor.png": 21129,
	"./exploud.png": 29565,
	"./falinks.png": 53459,
	"./farfetchd-galar.png": 86166,
	"./farfetchd.png": 84585,
	"./farigiraf.png": 63912,
	"./fearow.png": 67911,
	"./feebas.png": 81748,
	"./fennekin.png": 9306,
	"./feraligatr.png": 64227,
	"./ferroseed.png": 46544,
	"./ferrothorn.png": 91432,
	"./fidough.png": 15808,
	"./finizen.png": 31545,
	"./finneon.png": 11175,
	"./flaaffy.png": 25928,
	"./flabebe.png": 34587,
	"./flamigo.png": 47027,
	"./flapple-gmax.png": 58924,
	"./flapple.png": 40480,
	"./flareon.png": 58440,
	"./fletchinder.png": 14515,
	"./fletchling.png": 83456,
	"./flittle.png": 70424,
	"./floatzel.png": 51685,
	"./floette-eternal.png": 54035,
	"./floette.png": 64168,
	"./floragato.png": 81523,
	"./florges.png": 42664,
	"./flutter-mane.png": 84918,
	"./flygon.png": 86006,
	"./fomantis.png": 2143,
	"./foongus.png": 88820,
	"./forretress.png": 91483,
	"./fraxure.png": 5156,
	"./frigibax.png": 28837,
	"./frillish.png": 4628,
	"./froakie.png": 11936,
	"./frogadier.png": 59000,
	"./froslass.png": 50379,
	"./frosmoth.png": 64368,
	"./fuecoco.png": 33416,
	"./furfrou.png": 26349,
	"./furret.png": 41545,
	"./gabite.png": 7906,
	"./gallade-mega.png": 778,
	"./gallade.png": 55559,
	"./galvantula.png": 69468,
	"./garbodor-gmax.png": 75808,
	"./garbodor.png": 15052,
	"./garchomp-mega.png": 71943,
	"./garchomp.png": 50542,
	"./gardevoir-mega.png": 18475,
	"./gardevoir.png": 96362,
	"./garganacl.png": 72868,
	"./gastly.png": 14524,
	"./gastrodon.png": 9303,
	"./genesect.png": 9100,
	"./gengar-gmax.png": 37250,
	"./gengar-mega.png": 86653,
	"./gengar.png": 4980,
	"./geodude-alola.png": 35372,
	"./geodude.png": 12036,
	"./gholdengo.png": 38986,
	"./gible.png": 98115,
	"./gigalith.png": 79311,
	"./gimmighoul-roaming.png": 98708,
	"./gimmighoul.png": 21991,
	"./girafarig.png": 51118,
	"./giratina-altered.png": 6047,
	"./giratina-origin.png": 85075,
	"./glaceon.png": 90517,
	"./glalie-mega.png": 42025,
	"./glalie.png": 58600,
	"./glameow.png": 38743,
	"./glastrier.png": 36951,
	"./gligar.png": 9510,
	"./glimmet.png": 77691,
	"./glimmora.png": 26569,
	"./gliscor.png": 24155,
	"./gloom.png": 19917,
	"./gogoat.png": 14369,
	"./golbat.png": 1337,
	"./goldeen.png": 90792,
	"./golduck.png": 98053,
	"./golem-alola.png": 70639,
	"./golem.png": 7878,
	"./golett.png": 95332,
	"./golisopod.png": 60705,
	"./golurk.png": 93142,
	"./goodra-hisui.png": 49126,
	"./goodra.png": 14983,
	"./goomy.png": 32775,
	"./gorebyss.png": 71580,
	"./gossifleur.png": 81938,
	"./gothita.png": 33317,
	"./gothitelle.png": 57393,
	"./gothorita.png": 18382,
	"./gourgeist-average.png": 10400,
	"./gourgeist-large.png": 11793,
	"./gourgeist-small.png": 60610,
	"./gourgeist-super.png": 70927,
	"./grafaiai.png": 82121,
	"./granbull.png": 19685,
	"./grapploct.png": 14365,
	"./graveler-alola.png": 32586,
	"./graveler.png": 5038,
	"./great-tusk.png": 13444,
	"./greavard.png": 1808,
	"./greedent.png": 6123,
	"./greninja-ash.png": 86794,
	"./greninja-battle-bond.png": 6856,
	"./greninja.png": 81433,
	"./grimer-alola.png": 84085,
	"./grimer.png": 32753,
	"./grimmsnarl-gmax.png": 2553,
	"./grimmsnarl.png": 39673,
	"./grookey.png": 70582,
	"./grotle.png": 99215,
	"./groudon-primal.png": 21233,
	"./groudon.png": 2137,
	"./grovyle.png": 82726,
	"./growlithe-hisui.png": 2327,
	"./growlithe.png": 87909,
	"./grubbin.png": 62953,
	"./grumpig.png": 67692,
	"./gulpin.png": 25010,
	"./gumshoos-totem.png": 42595,
	"./gumshoos.png": 47828,
	"./gurdurr.png": 973,
	"./guzzlord.png": 37176,
	"./gyarados-mega.png": 84224,
	"./gyarados.png": 41789,
	"./hakamo-o.png": 18554,
	"./happiny.png": 98833,
	"./hariyama.png": 66766,
	"./hatenna.png": 71727,
	"./hatterene-gmax.png": 10637,
	"./hatterene.png": 97551,
	"./hattrem.png": 47103,
	"./haunter.png": 6780,
	"./hawlucha.png": 92852,
	"./haxorus.png": 51070,
	"./heatmor.png": 49241,
	"./heatran.png": 30359,
	"./heliolisk.png": 64900,
	"./helioptile.png": 70454,
	"./heracross-mega.png": 30562,
	"./heracross.png": 35319,
	"./herdier.png": 12422,
	"./hippopotas.png": 42366,
	"./hippowdon.png": 39212,
	"./hitmonchan.png": 66777,
	"./hitmonlee.png": 65567,
	"./hitmontop.png": 2841,
	"./ho-oh.png": 87846,
	"./honchkrow.png": 93808,
	"./honedge.png": 19791,
	"./hoopa-unbound.png": 73897,
	"./hoopa.png": 76388,
	"./hoothoot.png": 40983,
	"./hoppip.png": 17332,
	"./horsea.png": 45934,
	"./houndoom-mega.png": 10876,
	"./houndoom.png": 79761,
	"./houndour.png": 23977,
	"./houndstone.png": 11549,
	"./huntail.png": 28705,
	"./hydreigon.png": 51166,
	"./hypno.png": 72534,
	"./igglybuff.png": 91725,
	"./illumise.png": 73749,
	"./impidimp.png": 95474,
	"./incineroar.png": 22679,
	"./indeedee-female.png": 17060,
	"./indeedee-male.png": 13925,
	"./infernape.png": 84655,
	"./inkay.png": 78742,
	"./inteleon-gmax.png": 42083,
	"./inteleon.png": 4337,
	"./iron-bundle.png": 30769,
	"./iron-hands.png": 20558,
	"./iron-jugulis.png": 62229,
	"./iron-leaves.png": 92084,
	"./iron-moth.png": 90564,
	"./iron-thorns.png": 7304,
	"./iron-treads.png": 91,
	"./iron-valiant.png": 40930,
	"./ivysaur.png": 87863,
	"./jangmo-o.png": 96666,
	"./jellicent.png": 23776,
	"./jigglypuff.png": 22963,
	"./jirachi.png": 76718,
	"./jolteon.png": 9501,
	"./joltik.png": 2451,
	"./jumpluff.png": 98657,
	"./jynx.png": 44830,
	"./kabuto.png": 31583,
	"./kabutops.png": 16125,
	"./kadabra.png": 70701,
	"./kakuna.png": 8738,
	"./kangaskhan-mega.png": 77809,
	"./kangaskhan.png": 47971,
	"./karrablast.png": 10325,
	"./kartana.png": 57465,
	"./kecleon.png": 90353,
	"./keldeo-ordinary.png": 45596,
	"./keldeo-resolute.png": 24232,
	"./kilowattrel.png": 10202,
	"./kingambit.png": 8486,
	"./kingdra.png": 47282,
	"./kingler-gmax.png": 40855,
	"./kingler.png": 48130,
	"./kirlia.png": 76990,
	"./klang.png": 94611,
	"./klawf.png": 68751,
	"./kleavor.png": 53043,
	"./klefki.png": 44171,
	"./klink.png": 61836,
	"./klinklang.png": 72371,
	"./koffing.png": 72538,
	"./komala.png": 18428,
	"./kommo-o-totem.png": 33794,
	"./kommo-o.png": 78962,
	"./koraidon.png": 58330,
	"./krabby.png": 96993,
	"./kricketot.png": 67118,
	"./kricketune.png": 76357,
	"./krokorok.png": 23251,
	"./krookodile.png": 31080,
	"./kubfu.png": 33488,
	"./kyogre-primal.png": 22966,
	"./kyogre.png": 19134,
	"./kyurem-black.png": 98770,
	"./kyurem-white.png": 83681,
	"./kyurem.png": 85056,
	"./lairon.png": 63569,
	"./lampent.png": 90799,
	"./landorus-incarnate.png": 1646,
	"./landorus-therian.png": 89285,
	"./lanturn.png": 54359,
	"./lapras-gmax.png": 29336,
	"./lapras.png": 42743,
	"./larvesta.png": 9593,
	"./larvitar.png": 84860,
	"./latias-mega.png": 92825,
	"./latias.png": 87345,
	"./latios-mega.png": 48314,
	"./latios.png": 81490,
	"./leafeon.png": 99367,
	"./leavanny.png": 83966,
	"./lechonk.png": 4580,
	"./ledian.png": 35377,
	"./ledyba.png": 61187,
	"./lickilicky.png": 21015,
	"./lickitung.png": 51174,
	"./liepard.png": 50796,
	"./lileep.png": 40709,
	"./lilligant-hisui.png": 85805,
	"./lilligant.png": 55999,
	"./lillipup.png": 2387,
	"./linoone-galar.png": 89458,
	"./linoone.png": 69888,
	"./litleo.png": 72966,
	"./litten.png": 89741,
	"./litwick.png": 84388,
	"./lokix.png": 81253,
	"./lombre.png": 24658,
	"./lopunny-mega.png": 29971,
	"./lopunny.png": 16825,
	"./lotad.png": 33147,
	"./loudred.png": 72996,
	"./lucario-mega.png": 36358,
	"./lucario.png": 93399,
	"./ludicolo.png": 44422,
	"./lugia.png": 58596,
	"./lumineon.png": 83585,
	"./lunala.png": 22613,
	"./lunatone.png": 41084,
	"./lurantis-totem.png": 94856,
	"./lurantis.png": 98688,
	"./luvdisc.png": 28887,
	"./luxio.png": 55515,
	"./luxray.png": 52660,
	"./lycanroc-dusk.png": 54305,
	"./lycanroc-midday.png": 41774,
	"./lycanroc-midnight.png": 93374,
	"./mabosstiff.png": 47388,
	"./machamp-gmax.png": 25657,
	"./machamp.png": 65374,
	"./machoke.png": 12249,
	"./machop.png": 10346,
	"./magby.png": 59441,
	"./magcargo.png": 12833,
	"./magearna-original.png": 26949,
	"./magearna.png": 35674,
	"./magikarp.png": 35745,
	"./magmar.png": 18351,
	"./magmortar.png": 93345,
	"./magnemite.png": 32465,
	"./magneton.png": 64851,
	"./magnezone.png": 45230,
	"./makuhita.png": 57731,
	"./malamar.png": 99674,
	"./mamoswine.png": 67980,
	"./manaphy.png": 94671,
	"./mandibuzz.png": 71932,
	"./manectric-mega.png": 75233,
	"./manectric.png": 3014,
	"./mankey.png": 23684,
	"./mantine.png": 27554,
	"./mantyke.png": 25589,
	"./maractus.png": 99719,
	"./mareanie.png": 4130,
	"./mareep.png": 5454,
	"./marill.png": 98896,
	"./marowak-alola.png": 67802,
	"./marowak-totem.png": 39477,
	"./marowak.png": 74089,
	"./marshadow.png": 22634,
	"./marshtomp.png": 98188,
	"./maschiff.png": 21437,
	"./masquerain.png": 61932,
	"./maushold-family-of-three.png": 61962,
	"./maushold.png": 4634,
	"./mawile-mega.png": 56178,
	"./mawile.png": 96937,
	"./medicham-mega.png": 67330,
	"./medicham.png": 21465,
	"./meditite.png": 25304,
	"./meganium.png": 68385,
	"./melmetal-gmax.png": 4762,
	"./melmetal.png": 29195,
	"./meloetta-aria.png": 5739,
	"./meloetta-pirouette.png": 509,
	"./meltan.png": 24421,
	"./meowscarada.png": 32008,
	"./meowstic-female.png": 91505,
	"./meowstic-male.png": 75475,
	"./meowth-alola.png": 19402,
	"./meowth-galar.png": 12986,
	"./meowth-gmax.png": 66049,
	"./meowth.png": 84692,
	"./mesprit.png": 42529,
	"./metagross-mega.png": 38147,
	"./metagross.png": 3061,
	"./metang.png": 33662,
	"./metapod.png": 55808,
	"./mew.png": 60255,
	"./mewtwo-mega-x.png": 63725,
	"./mewtwo-mega-y.png": 60253,
	"./mewtwo.png": 77131,
	"./mienfoo.png": 78443,
	"./mienshao.png": 63562,
	"./mightyena.png": 91448,
	"./milcery.png": 85625,
	"./milotic.png": 83820,
	"./miltank.png": 29527,
	"./mime-jr.png": 11684,
	"./mimikyu-disguised.png": 36340,
	"./mimikyu-totem-disguised.png": 6925,
	"./minccino.png": 17823,
	"./minior-blue-meteor.png": 72119,
	"./minior-blue.png": 37131,
	"./minior-green-meteor.png": 69980,
	"./minior-green.png": 59939,
	"./minior-indigo-meteor.png": 10957,
	"./minior-indigo.png": 24760,
	"./minior-orange-meteor.png": 83421,
	"./minior-orange.png": 56557,
	"./minior-red-meteor.png": 78557,
	"./minior-red.png": 91729,
	"./minior-violet-meteor.png": 59879,
	"./minior-violet.png": 16054,
	"./minior-yellow-meteor.png": 38040,
	"./minior-yellow.png": 33318,
	"./minun.png": 51782,
	"./miraidon.png": 6824,
	"./misdreavus.png": 56083,
	"./mismagius.png": 64363,
	"./moltres-galar.png": 51101,
	"./moltres.png": 95512,
	"./monferno.png": 60403,
	"./morelull.png": 49529,
	"./morgrem.png": 9325,
	"./morpeko-full-belly.png": 46533,
	"./morpeko-hangry.png": 88175,
	"./mothim.png": 45881,
	"./mr-mime-galar.png": 16378,
	"./mr-mime.png": 41093,
	"./mr-rime.png": 23747,
	"./mudbray.png": 96590,
	"./mudkip.png": 48119,
	"./mudsdale.png": 88143,
	"./muk-alola.png": 73363,
	"./muk.png": 93970,
	"./munchlax.png": 99891,
	"./munna.png": 99853,
	"./murkrow.png": 28047,
	"./musharna.png": 56858,
	"./nacli.png": 52463,
	"./naclstack.png": 70461,
	"./naganadel.png": 19964,
	"./natu.png": 66099,
	"./necrozma-dawn.png": 35725,
	"./necrozma-dusk.png": 7075,
	"./necrozma-ultra.png": 33115,
	"./necrozma.png": 85921,
	"./nickit.png": 11893,
	"./nidoking.png": 63088,
	"./nidoqueen.png": 26522,
	"./nidoran-f.png": 78069,
	"./nidoran-m.png": 52120,
	"./nidorina.png": 53398,
	"./nidorino.png": 98419,
	"./nihilego.png": 31909,
	"./nincada.png": 7352,
	"./ninetales-alola.png": 181,
	"./ninetales.png": 94179,
	"./ninjask.png": 36220,
	"./noctowl.png": 93986,
	"./noibat.png": 86725,
	"./noivern.png": 44929,
	"./nosepass.png": 19063,
	"./numel.png": 44283,
	"./nuzleaf.png": 68550,
	"./nymble.png": 46788,
	"./obstagoon.png": 26691,
	"./octillery.png": 14251,
	"./oddish.png": 89023,
	"./oinkologne-female.png": 87888,
	"./oinkologne.png": 76672,
	"./omanyte.png": 18098,
	"./omastar.png": 36237,
	"./onix.png": 74347,
	"./oranguru.png": 59896,
	"./orbeetle-gmax.png": 94316,
	"./orbeetle.png": 53204,
	"./oricorio-baile.png": 28069,
	"./oricorio-pau.png": 29831,
	"./oricorio-pom-pom.png": 94881,
	"./oricorio-sensu.png": 29059,
	"./orthworm.png": 3923,
	"./oshawott.png": 48863,
	"./overqwil.png": 98337,
	"./pachirisu.png": 46196,
	"./palafin-hero.png": 22823,
	"./palafin.png": 61876,
	"./palkia-origin.png": 36309,
	"./palkia.png": 54412,
	"./palossand.png": 56986,
	"./palpitoad.png": 23257,
	"./pancham.png": 63400,
	"./pangoro.png": 22708,
	"./panpour.png": 36586,
	"./pansage.png": 71199,
	"./pansear.png": 82285,
	"./paras.png": 56275,
	"./parasect.png": 98923,
	"./passimian.png": 87928,
	"./patrat.png": 12026,
	"./pawmi.png": 62035,
	"./pawmo.png": 40663,
	"./pawmot.png": 18418,
	"./pawniard.png": 28315,
	"./pelipper.png": 54850,
	"./perrserker.png": 61552,
	"./persian-alola.png": 68040,
	"./persian.png": 63053,
	"./petilil.png": 34625,
	"./phanpy.png": 83199,
	"./phantump.png": 23370,
	"./pheromosa.png": 76666,
	"./phione.png": 24595,
	"./pichu.png": 69064,
	"./pidgeot-mega.png": 69037,
	"./pidgeot.png": 72698,
	"./pidgeotto.png": 55025,
	"./pidgey.png": 17524,
	"./pidove.png": 76420,
	"./pignite.png": 36995,
	"./pikachu-alola-cap.png": 17029,
	"./pikachu-belle.png": 11104,
	"./pikachu-cosplay.png": 26451,
	"./pikachu-gmax.png": 11894,
	"./pikachu-hoenn-cap.png": 66851,
	"./pikachu-kalos-cap.png": 74530,
	"./pikachu-libre.png": 13883,
	"./pikachu-original-cap.png": 29818,
	"./pikachu-partner-cap.png": 25893,
	"./pikachu-phd.png": 50931,
	"./pikachu-pop-star.png": 8187,
	"./pikachu-rock-star.png": 4880,
	"./pikachu-sinnoh-cap.png": 61546,
	"./pikachu-starter.png": 54149,
	"./pikachu-unova-cap.png": 93400,
	"./pikachu-world-cap.png": 86536,
	"./pikachu.png": 29525,
	"./pikipek.png": 40462,
	"./piloswine.png": 53634,
	"./pincurchin.png": 67830,
	"./pineco.png": 93110,
	"./pinsir-mega.png": 64979,
	"./pinsir.png": 69244,
	"./piplup.png": 68152,
	"./plusle.png": 20167,
	"./poipole.png": 70915,
	"./politoed.png": 36572,
	"./poliwag.png": 47741,
	"./poliwhirl.png": 51605,
	"./poliwrath.png": 83568,
	"./polteageist.png": 34600,
	"./ponyta-galar.png": 25253,
	"./ponyta.png": 90000,
	"./poochyena.png": 33035,
	"./popplio.png": 26403,
	"./porygon-z.png": 23314,
	"./porygon.png": 13409,
	"./porygon2.png": 31851,
	"./primarina.png": 83970,
	"./primeape.png": 31034,
	"./prinplup.png": 64080,
	"./probopass.png": 23090,
	"./psyduck.png": 12027,
	"./pumpkaboo-average.png": 62996,
	"./pumpkaboo-large.png": 70641,
	"./pumpkaboo-small.png": 46875,
	"./pumpkaboo-super.png": 79627,
	"./pupitar.png": 87044,
	"./purrloin.png": 74483,
	"./purugly.png": 74653,
	"./pyroar.png": 79079,
	"./pyukumuku.png": 80815,
	"./quagsire.png": 71714,
	"./quaquaval.png": 93795,
	"./quaxly.png": 44393,
	"./quaxwell.png": 83072,
	"./quilava.png": 22451,
	"./quilladin.png": 54085,
	"./qwilfish-hisui.png": 56910,
	"./qwilfish.png": 30472,
	"./raboot.png": 37430,
	"./rabsca.png": 16541,
	"./raichu-alola.png": 37904,
	"./raichu.png": 6333,
	"./raikou.png": 60684,
	"./ralts.png": 44561,
	"./rampardos.png": 43702,
	"./rapidash-galar.png": 57821,
	"./rapidash.png": 65835,
	"./raticate-alola.png": 66561,
	"./raticate-totem-alola.png": 54633,
	"./raticate.png": 74670,
	"./rattata-alola.png": 79445,
	"./rattata.png": 56246,
	"./rayquaza-mega.png": 86566,
	"./rayquaza.png": 92017,
	"./regice.png": 1215,
	"./regidrago.png": 10865,
	"./regieleki.png": 63041,
	"./regigigas.png": 74638,
	"./regirock.png": 46066,
	"./registeel.png": 35570,
	"./relicanth.png": 34430,
	"./rellor.png": 98622,
	"./remoraid.png": 18250,
	"./reshiram.png": 91380,
	"./reuniclus.png": 76889,
	"./revavroom.png": 23169,
	"./rhydon.png": 64124,
	"./rhyhorn.png": 60307,
	"./rhyperior.png": 78227,
	"./ribombee-totem.png": 58028,
	"./ribombee.png": 10248,
	"./rillaboom-gmax.png": 85798,
	"./rillaboom.png": 79474,
	"./riolu.png": 13776,
	"./roaring-moon.png": 86176,
	"./rockruff-own-tempo.png": 47991,
	"./rockruff.png": 76693,
	"./roggenrola.png": 77006,
	"./rolycoly.png": 42324,
	"./rookidee.png": 74184,
	"./roselia.png": 89620,
	"./roserade.png": 2139,
	"./rotom-fan.png": 67550,
	"./rotom-frost.png": 68584,
	"./rotom-heat.png": 25346,
	"./rotom-mow.png": 54702,
	"./rotom-wash.png": 23015,
	"./rotom.png": 34066,
	"./rowlet.png": 34715,
	"./rufflet.png": 27728,
	"./runerigus.png": 1130,
	"./sableye-mega.png": 95465,
	"./sableye.png": 83599,
	"./salamence-mega.png": 64357,
	"./salamence.png": 2191,
	"./salandit.png": 51676,
	"./salazzle-totem.png": 92732,
	"./salazzle.png": 77686,
	"./samurott-hisui.png": 42994,
	"./samurott.png": 63791,
	"./sandaconda-gmax.png": 71880,
	"./sandaconda.png": 85580,
	"./sandile.png": 86833,
	"./sandshrew-alola.png": 59482,
	"./sandshrew.png": 40200,
	"./sandslash-alola.png": 53324,
	"./sandslash.png": 82265,
	"./sandy-shocks.png": 32670,
	"./sandygast.png": 64382,
	"./sawk.png": 44704,
	"./sawsbuck.png": 53217,
	"./scatterbug.png": 18751,
	"./sceptile-mega.png": 51790,
	"./sceptile.png": 26377,
	"./scizor-mega.png": 33660,
	"./scizor.png": 80129,
	"./scolipede.png": 13057,
	"./scorbunny.png": 11304,
	"./scovillain.png": 70171,
	"./scrafty.png": 65957,
	"./scraggy.png": 54626,
	"./scream-tail.png": 74272,
	"./scyther.png": 6393,
	"./seadra.png": 72656,
	"./seaking.png": 17030,
	"./sealeo.png": 31729,
	"./seedot.png": 14095,
	"./seel.png": 51697,
	"./seismitoad.png": 30130,
	"./sentret.png": 81691,
	"./serperior.png": 15871,
	"./servine.png": 3651,
	"./seviper.png": 43955,
	"./sewaddle.png": 79231,
	"./sharpedo-mega.png": 80293,
	"./sharpedo.png": 51661,
	"./shaymin-land.png": 38110,
	"./shaymin-sky.png": 60180,
	"./shedinja.png": 93843,
	"./shelgon.png": 84140,
	"./shellder.png": 9426,
	"./shellos.png": 52869,
	"./shelmet.png": 74879,
	"./shieldon.png": 87799,
	"./shiftry.png": 85631,
	"./shiinotic.png": 53435,
	"./shinx.png": 58835,
	"./shiny/1.png": 71858,
	"./shiny/10.png": 58116,
	"./shiny/100.png": 40885,
	"./shiny/1000.png": 93801,
	"./shiny/10001.png": 61290,
	"./shiny/10002.png": 54297,
	"./shiny/10003.png": 21450,
	"./shiny/10004.png": 72367,
	"./shiny/10005.png": 57746,
	"./shiny/10006.png": 27435,
	"./shiny/10007.png": 85955,
	"./shiny/10008.png": 19099,
	"./shiny/10009.png": 6444,
	"./shiny/1001.png": 46147,
	"./shiny/10010.png": 25373,
	"./shiny/10011.png": 15842,
	"./shiny/10012.png": 78883,
	"./shiny/10013.png": 88508,
	"./shiny/10014.png": 86273,
	"./shiny/10015.png": 73657,
	"./shiny/10016.png": 92194,
	"./shiny/10017.png": 48949,
	"./shiny/10018.png": 84289,
	"./shiny/10019.png": 48401,
	"./shiny/1002.png": 31920,
	"./shiny/10020.png": 94540,
	"./shiny/10021.png": 84312,
	"./shiny/10022.png": 67327,
	"./shiny/10023.png": 13855,
	"./shiny/10024.png": 85146,
	"./shiny/10026.png": 44194,
	"./shiny/10027.png": 41934,
	"./shiny/10028.png": 93029,
	"./shiny/10029.png": 84744,
	"./shiny/1003.png": 15602,
	"./shiny/10030.png": 76999,
	"./shiny/10031.png": 79760,
	"./shiny/10032.png": 97146,
	"./shiny/10033.png": 93937,
	"./shiny/10034.png": 10900,
	"./shiny/10035.png": 9027,
	"./shiny/10036.png": 24129,
	"./shiny/10037.png": 56523,
	"./shiny/10038.png": 18664,
	"./shiny/10039.png": 78372,
	"./shiny/1004.png": 92720,
	"./shiny/10040.png": 88374,
	"./shiny/10041.png": 38312,
	"./shiny/10042.png": 88406,
	"./shiny/10043.png": 81566,
	"./shiny/10044.png": 51695,
	"./shiny/10045.png": 73872,
	"./shiny/10046.png": 67747,
	"./shiny/10047.png": 59351,
	"./shiny/10048.png": 89581,
	"./shiny/10049.png": 55014,
	"./shiny/1005.png": 27427,
	"./shiny/10050.png": 74788,
	"./shiny/10051.png": 69542,
	"./shiny/10052.png": 97531,
	"./shiny/10053.png": 19876,
	"./shiny/10054.png": 85014,
	"./shiny/10055.png": 87115,
	"./shiny/10056.png": 52843,
	"./shiny/10057.png": 71878,
	"./shiny/10058.png": 98733,
	"./shiny/10059.png": 49640,
	"./shiny/1006.png": 72383,
	"./shiny/10060.png": 70465,
	"./shiny/10061.png": 90404,
	"./shiny/10062.png": 93702,
	"./shiny/10063.png": 15039,
	"./shiny/10064.png": 76033,
	"./shiny/10065.png": 82796,
	"./shiny/10066.png": 49734,
	"./shiny/10067.png": 46970,
	"./shiny/10068.png": 36782,
	"./shiny/10069.png": 34369,
	"./shiny/1007.png": 39253,
	"./shiny/10070.png": 44761,
	"./shiny/10071.png": 32590,
	"./shiny/10072.png": 68133,
	"./shiny/10073.png": 82324,
	"./shiny/10074.png": 4339,
	"./shiny/10075.png": 15031,
	"./shiny/10076.png": 9309,
	"./shiny/10077.png": 33074,
	"./shiny/10078.png": 13254,
	"./shiny/10079.png": 30892,
	"./shiny/1008.png": 14372,
	"./shiny/10080.png": 48466,
	"./shiny/10081.png": 89823,
	"./shiny/10082.png": 77379,
	"./shiny/10083.png": 4006,
	"./shiny/10084.png": 2463,
	"./shiny/10086.png": 97002,
	"./shiny/10087.png": 49232,
	"./shiny/10088.png": 96010,
	"./shiny/10089.png": 50130,
	"./shiny/10090.png": 2234,
	"./shiny/10091.png": 40421,
	"./shiny/10092.png": 73349,
	"./shiny/10093.png": 42888,
	"./shiny/10094.png": 41955,
	"./shiny/10095.png": 45826,
	"./shiny/10096.png": 31187,
	"./shiny/10097.png": 29241,
	"./shiny/10098.png": 25991,
	"./shiny/10099.png": 19709,
	"./shiny/101.png": 79860,
	"./shiny/10100.png": 54498,
	"./shiny/10101.png": 29742,
	"./shiny/10102.png": 8918,
	"./shiny/10103.png": 85906,
	"./shiny/10104.png": 63729,
	"./shiny/10105.png": 44482,
	"./shiny/10106.png": 5648,
	"./shiny/10107.png": 25172,
	"./shiny/10108.png": 50393,
	"./shiny/10109.png": 34805,
	"./shiny/10110.png": 97588,
	"./shiny/10111.png": 84699,
	"./shiny/10112.png": 52808,
	"./shiny/10113.png": 33852,
	"./shiny/10114.png": 38971,
	"./shiny/10115.png": 4990,
	"./shiny/10117.png": 41319,
	"./shiny/10118.png": 80477,
	"./shiny/10119.png": 22279,
	"./shiny/10120.png": 99687,
	"./shiny/10121.png": 2905,
	"./shiny/10122.png": 40837,
	"./shiny/10123.png": 25377,
	"./shiny/10124.png": 89278,
	"./shiny/10125.png": 93055,
	"./shiny/10126.png": 87437,
	"./shiny/10127.png": 1981,
	"./shiny/10128.png": 20861,
	"./shiny/10129.png": 62836,
	"./shiny/10130.png": 77153,
	"./shiny/10131.png": 20256,
	"./shiny/10132.png": 55385,
	"./shiny/10133.png": 31342,
	"./shiny/10134.png": 48054,
	"./shiny/10135.png": 15667,
	"./shiny/10136.png": 54284,
	"./shiny/10137.png": 19574,
	"./shiny/10138.png": 16752,
	"./shiny/10139.png": 39468,
	"./shiny/10140.png": 2439,
	"./shiny/10141.png": 2963,
	"./shiny/10142.png": 78528,
	"./shiny/10143.png": 64970,
	"./shiny/10146.png": 76571,
	"./shiny/10147.png": 50253,
	"./shiny/10149.png": 65898,
	"./shiny/10150.png": 95732,
	"./shiny/10151.png": 19061,
	"./shiny/10152.png": 95382,
	"./shiny/10153.png": 40786,
	"./shiny/10154.png": 92570,
	"./shiny/10155.png": 31357,
	"./shiny/10156.png": 11545,
	"./shiny/10157.png": 47775,
	"./shiny/10161.png": 84802,
	"./shiny/10162.png": 62853,
	"./shiny/10163.png": 49148,
	"./shiny/10164.png": 66828,
	"./shiny/10165.png": 31691,
	"./shiny/10166.png": 57770,
	"./shiny/10167.png": 50514,
	"./shiny/10168.png": 47773,
	"./shiny/10169.png": 13222,
	"./shiny/10170.png": 33192,
	"./shiny/10171.png": 70863,
	"./shiny/10172.png": 75323,
	"./shiny/10173.png": 60852,
	"./shiny/10174.png": 63466,
	"./shiny/10175.png": 11775,
	"./shiny/10176.png": 84338,
	"./shiny/10177.png": 94123,
	"./shiny/10178.png": 65970,
	"./shiny/10179.png": 36728,
	"./shiny/10180.png": 92850,
	"./shiny/10181.png": 30419,
	"./shiny/10182.png": 63773,
	"./shiny/10183.png": 88139,
	"./shiny/10184.png": 30180,
	"./shiny/10185.png": 52802,
	"./shiny/10186.png": 79373,
	"./shiny/10187.png": 28476,
	"./shiny/10188.png": 3661,
	"./shiny/10189.png": 78273,
	"./shiny/10190.png": 76824,
	"./shiny/10191.png": 60380,
	"./shiny/10193.png": 86556,
	"./shiny/10194.png": 77423,
	"./shiny/10195.png": 39330,
	"./shiny/10196.png": 73435,
	"./shiny/10197.png": 37618,
	"./shiny/10198.png": 9835,
	"./shiny/10199.png": 44428,
	"./shiny/102.png": 46090,
	"./shiny/10200.png": 13539,
	"./shiny/10201.png": 17527,
	"./shiny/10202.png": 82437,
	"./shiny/10203.png": 77841,
	"./shiny/10204.png": 95524,
	"./shiny/10205.png": 98962,
	"./shiny/10206.png": 58168,
	"./shiny/10207.png": 48554,
	"./shiny/10208.png": 50005,
	"./shiny/10209.png": 35022,
	"./shiny/10210.png": 22748,
	"./shiny/10211.png": 19797,
	"./shiny/10212.png": 9881,
	"./shiny/10213.png": 11049,
	"./shiny/10214.png": 16616,
	"./shiny/10215.png": 10708,
	"./shiny/10216.png": 26887,
	"./shiny/10217.png": 75301,
	"./shiny/10218.png": 52778,
	"./shiny/10219.png": 89070,
	"./shiny/10220.png": 36397,
	"./shiny/10221.png": 42112,
	"./shiny/10222.png": 29055,
	"./shiny/10223.png": 35592,
	"./shiny/10224.png": 21134,
	"./shiny/10225.png": 89616,
	"./shiny/10226.png": 80708,
	"./shiny/10227.png": 86501,
	"./shiny/10228.png": 35881,
	"./shiny/10229.png": 6054,
	"./shiny/10230.png": 74351,
	"./shiny/10231.png": 14188,
	"./shiny/10232.png": 20802,
	"./shiny/10233.png": 98464,
	"./shiny/10234.png": 46318,
	"./shiny/10235.png": 8226,
	"./shiny/10236.png": 57324,
	"./shiny/10237.png": 44850,
	"./shiny/10238.png": 8661,
	"./shiny/10239.png": 30365,
	"./shiny/10240.png": 58351,
	"./shiny/10241.png": 46142,
	"./shiny/10242.png": 99795,
	"./shiny/10243.png": 89514,
	"./shiny/10244.png": 53767,
	"./shiny/10245.png": 95773,
	"./shiny/10246.png": 84976,
	"./shiny/10247.png": 87840,
	"./shiny/10248.png": 41849,
	"./shiny/10249.png": 65669,
	"./shiny/10250.png": 4365,
	"./shiny/10251.png": 61329,
	"./shiny/10252.png": 6607,
	"./shiny/10253.png": 68965,
	"./shiny/10254.png": 91461,
	"./shiny/10256.png": 70096,
	"./shiny/10258.png": 10478,
	"./shiny/10259.png": 29886,
	"./shiny/10260.png": 68276,
	"./shiny/10261.png": 31618,
	"./shiny/10262.png": 31266,
	"./shiny/10263.png": 87722,
	"./shiny/103.png": 50940,
	"./shiny/104.png": 95900,
	"./shiny/105.png": 85341,
	"./shiny/106.png": 43919,
	"./shiny/107.png": 91965,
	"./shiny/108.png": 16777,
	"./shiny/109.png": 85979,
	"./shiny/11.png": 50245,
	"./shiny/110.png": 26470,
	"./shiny/111.png": 93201,
	"./shiny/112.png": 32074,
	"./shiny/113.png": 81162,
	"./shiny/114.png": 27743,
	"./shiny/115.png": 92336,
	"./shiny/116.png": 252,
	"./shiny/117.png": 38558,
	"./shiny/118.png": 76592,
	"./shiny/119.png": 58264,
	"./shiny/12.png": 22231,
	"./shiny/120.png": 21055,
	"./shiny/121.png": 2916,
	"./shiny/122.png": 88714,
	"./shiny/123.png": 14177,
	"./shiny/124.png": 8784,
	"./shiny/125.png": 64454,
	"./shiny/126.png": 15001,
	"./shiny/127.png": 21446,
	"./shiny/128.png": 74794,
	"./shiny/129.png": 40813,
	"./shiny/13.png": 21825,
	"./shiny/130.png": 89779,
	"./shiny/131.png": 6114,
	"./shiny/132.png": 52050,
	"./shiny/133.png": 31469,
	"./shiny/134.png": 53861,
	"./shiny/135.png": 14418,
	"./shiny/136.png": 70883,
	"./shiny/137.png": 95553,
	"./shiny/138.png": 64976,
	"./shiny/139.png": 63586,
	"./shiny/14.png": 38687,
	"./shiny/140.png": 69884,
	"./shiny/141.png": 12483,
	"./shiny/142.png": 9631,
	"./shiny/143.png": 75819,
	"./shiny/144.png": 73141,
	"./shiny/145.png": 38043,
	"./shiny/146.png": 85322,
	"./shiny/147.png": 9706,
	"./shiny/148.png": 90446,
	"./shiny/149.png": 4400,
	"./shiny/15.png": 31874,
	"./shiny/150.png": 89500,
	"./shiny/151.png": 44612,
	"./shiny/152.png": 62647,
	"./shiny/153.png": 50249,
	"./shiny/154.png": 38328,
	"./shiny/155.png": 80948,
	"./shiny/156.png": 38807,
	"./shiny/157.png": 51409,
	"./shiny/158.png": 23428,
	"./shiny/159.png": 20830,
	"./shiny/16.png": 54627,
	"./shiny/160.png": 41229,
	"./shiny/161.png": 3402,
	"./shiny/162.png": 43990,
	"./shiny/163.png": 60487,
	"./shiny/164.png": 9532,
	"./shiny/165.png": 66994,
	"./shiny/166.png": 56389,
	"./shiny/167.png": 54945,
	"./shiny/168.png": 66978,
	"./shiny/169.png": 94375,
	"./shiny/17.png": 69399,
	"./shiny/170.png": 54276,
	"./shiny/171.png": 8036,
	"./shiny/172.png": 28073,
	"./shiny/173.png": 32735,
	"./shiny/174.png": 18589,
	"./shiny/175.png": 27490,
	"./shiny/176.png": 50160,
	"./shiny/177.png": 21402,
	"./shiny/178.png": 15361,
	"./shiny/179.png": 97802,
	"./shiny/18.png": 46606,
	"./shiny/180.png": 72523,
	"./shiny/181.png": 36749,
	"./shiny/182.png": 17331,
	"./shiny/183.png": 67023,
	"./shiny/184.png": 55874,
	"./shiny/185.png": 82223,
	"./shiny/186.png": 1826,
	"./shiny/187.png": 60366,
	"./shiny/188.png": 2157,
	"./shiny/189.png": 58883,
	"./shiny/19.png": 81217,
	"./shiny/190.png": 65741,
	"./shiny/191.png": 17011,
	"./shiny/192.png": 96527,
	"./shiny/193.png": 85283,
	"./shiny/194.png": 84202,
	"./shiny/195.png": 69866,
	"./shiny/196.png": 96446,
	"./shiny/197.png": 95826,
	"./shiny/198.png": 93900,
	"./shiny/199.png": 36350,
	"./shiny/2.png": 61475,
	"./shiny/20.png": 48797,
	"./shiny/200.png": 71597,
	"./shiny/201.png": 84532,
	"./shiny/202.png": 83365,
	"./shiny/203.png": 78942,
	"./shiny/204.png": 75683,
	"./shiny/205.png": 59089,
	"./shiny/206.png": 17205,
	"./shiny/207.png": 7899,
	"./shiny/208.png": 29311,
	"./shiny/209.png": 65160,
	"./shiny/21.png": 88621,
	"./shiny/210.png": 4271,
	"./shiny/211.png": 4805,
	"./shiny/212.png": 82171,
	"./shiny/213.png": 38821,
	"./shiny/214.png": 39586,
	"./shiny/215.png": 60032,
	"./shiny/216.png": 55714,
	"./shiny/217.png": 93926,
	"./shiny/218.png": 654,
	"./shiny/219.png": 5081,
	"./shiny/22.png": 71526,
	"./shiny/220.png": 25736,
	"./shiny/221.png": 77764,
	"./shiny/222.png": 49377,
	"./shiny/223.png": 96681,
	"./shiny/224.png": 5980,
	"./shiny/225.png": 5826,
	"./shiny/226.png": 94642,
	"./shiny/227.png": 30888,
	"./shiny/228.png": 59259,
	"./shiny/229.png": 49836,
	"./shiny/23.png": 92254,
	"./shiny/230.png": 82549,
	"./shiny/231.png": 65362,
	"./shiny/232.png": 8223,
	"./shiny/233.png": 85086,
	"./shiny/234.png": 86732,
	"./shiny/235.png": 33066,
	"./shiny/236.png": 11753,
	"./shiny/237.png": 25272,
	"./shiny/238.png": 99873,
	"./shiny/239.png": 19052,
	"./shiny/24.png": 36078,
	"./shiny/240.png": 1772,
	"./shiny/241.png": 23499,
	"./shiny/242.png": 41116,
	"./shiny/243.png": 46423,
	"./shiny/244.png": 74992,
	"./shiny/245.png": 27680,
	"./shiny/246.png": 32395,
	"./shiny/247.png": 94980,
	"./shiny/248.png": 97314,
	"./shiny/249.png": 91621,
	"./shiny/25.png": 75042,
	"./shiny/250.png": 31864,
	"./shiny/251.png": 29070,
	"./shiny/252.png": 63118,
	"./shiny/253.png": 5210,
	"./shiny/254.png": 26109,
	"./shiny/255.png": 49769,
	"./shiny/256.png": 78582,
	"./shiny/257.png": 89045,
	"./shiny/258.png": 68343,
	"./shiny/259.png": 93985,
	"./shiny/26.png": 57453,
	"./shiny/260.png": 80469,
	"./shiny/261.png": 18709,
	"./shiny/262.png": 19532,
	"./shiny/263.png": 2422,
	"./shiny/264.png": 49987,
	"./shiny/265.png": 97041,
	"./shiny/266.png": 441,
	"./shiny/267.png": 70889,
	"./shiny/268.png": 14987,
	"./shiny/269.png": 64404,
	"./shiny/27.png": 16122,
	"./shiny/270.png": 50718,
	"./shiny/271.png": 20563,
	"./shiny/272.png": 86563,
	"./shiny/273.png": 85409,
	"./shiny/274.png": 75300,
	"./shiny/275.png": 88001,
	"./shiny/276.png": 59270,
	"./shiny/277.png": 50328,
	"./shiny/278.png": 78602,
	"./shiny/279.png": 66842,
	"./shiny/28.png": 38185,
	"./shiny/280.png": 65976,
	"./shiny/281.png": 56290,
	"./shiny/282.png": 93200,
	"./shiny/283.png": 19378,
	"./shiny/284.png": 4543,
	"./shiny/285.png": 2297,
	"./shiny/286.png": 8981,
	"./shiny/287.png": 20800,
	"./shiny/288.png": 67317,
	"./shiny/289.png": 72058,
	"./shiny/29.png": 91251,
	"./shiny/290.png": 93082,
	"./shiny/291.png": 31959,
	"./shiny/292.png": 62840,
	"./shiny/293.png": 23410,
	"./shiny/294.png": 19442,
	"./shiny/295.png": 97060,
	"./shiny/296.png": 36225,
	"./shiny/297.png": 71101,
	"./shiny/298.png": 87146,
	"./shiny/299.png": 75208,
	"./shiny/3.png": 20863,
	"./shiny/30.png": 91766,
	"./shiny/300.png": 6879,
	"./shiny/301.png": 77499,
	"./shiny/302.png": 94818,
	"./shiny/303.png": 80085,
	"./shiny/304.png": 10313,
	"./shiny/305.png": 22958,
	"./shiny/306.png": 96384,
	"./shiny/307.png": 23327,
	"./shiny/308.png": 84595,
	"./shiny/309.png": 44840,
	"./shiny/31.png": 57400,
	"./shiny/310.png": 45759,
	"./shiny/311.png": 12558,
	"./shiny/312.png": 20588,
	"./shiny/313.png": 6693,
	"./shiny/314.png": 28567,
	"./shiny/315.png": 92498,
	"./shiny/316.png": 85217,
	"./shiny/317.png": 49298,
	"./shiny/318.png": 37740,
	"./shiny/319.png": 66105,
	"./shiny/32.png": 30213,
	"./shiny/320.png": 67104,
	"./shiny/321.png": 82615,
	"./shiny/322.png": 58185,
	"./shiny/323.png": 21403,
	"./shiny/324.png": 28706,
	"./shiny/325.png": 75228,
	"./shiny/326.png": 22213,
	"./shiny/327.png": 71794,
	"./shiny/328.png": 49060,
	"./shiny/329.png": 35850,
	"./shiny/33.png": 31753,
	"./shiny/330.png": 33282,
	"./shiny/331.png": 12408,
	"./shiny/332.png": 89766,
	"./shiny/333.png": 54514,
	"./shiny/334.png": 41667,
	"./shiny/335.png": 21788,
	"./shiny/336.png": 58630,
	"./shiny/337.png": 770,
	"./shiny/338.png": 61606,
	"./shiny/339.png": 24414,
	"./shiny/34.png": 32494,
	"./shiny/340.png": 82156,
	"./shiny/341.png": 29557,
	"./shiny/342.png": 6119,
	"./shiny/343.png": 9885,
	"./shiny/344.png": 13453,
	"./shiny/345.png": 15881,
	"./shiny/346.png": 1810,
	"./shiny/347.png": 94501,
	"./shiny/348.png": 5014,
	"./shiny/349.png": 95473,
	"./shiny/35.png": 77346,
	"./shiny/350.png": 8301,
	"./shiny/351.png": 92889,
	"./shiny/352.png": 78223,
	"./shiny/353.png": 46601,
	"./shiny/354.png": 76549,
	"./shiny/355.png": 39409,
	"./shiny/356.png": 73922,
	"./shiny/357.png": 92398,
	"./shiny/358.png": 55567,
	"./shiny/359.png": 83823,
	"./shiny/36.png": 37667,
	"./shiny/360.png": 51839,
	"./shiny/361.png": 83973,
	"./shiny/362.png": 67791,
	"./shiny/363.png": 41466,
	"./shiny/364.png": 48814,
	"./shiny/365.png": 32378,
	"./shiny/366.png": 95890,
	"./shiny/367.png": 50658,
	"./shiny/368.png": 49954,
	"./shiny/369.png": 17377,
	"./shiny/37.png": 55574,
	"./shiny/370.png": 49349,
	"./shiny/371.png": 32558,
	"./shiny/372.png": 58806,
	"./shiny/373.png": 77473,
	"./shiny/374.png": 22982,
	"./shiny/375.png": 58525,
	"./shiny/376.png": 17198,
	"./shiny/377.png": 8069,
	"./shiny/378.png": 78672,
	"./shiny/379.png": 61550,
	"./shiny/38.png": 22919,
	"./shiny/380.png": 47363,
	"./shiny/381.png": 81744,
	"./shiny/382.png": 12254,
	"./shiny/383.png": 83838,
	"./shiny/384.png": 36416,
	"./shiny/385.png": 82142,
	"./shiny/386.png": 49622,
	"./shiny/387.png": 14186,
	"./shiny/388.png": 95244,
	"./shiny/389.png": 10397,
	"./shiny/39.png": 36174,
	"./shiny/390.png": 78797,
	"./shiny/391.png": 67260,
	"./shiny/392.png": 7177,
	"./shiny/393.png": 29489,
	"./shiny/394.png": 6570,
	"./shiny/395.png": 73931,
	"./shiny/396.png": 14550,
	"./shiny/397.png": 85760,
	"./shiny/398.png": 23635,
	"./shiny/399.png": 84910,
	"./shiny/4.png": 21707,
	"./shiny/40.png": 36018,
	"./shiny/400.png": 28501,
	"./shiny/401.png": 7248,
	"./shiny/402.png": 99413,
	"./shiny/403.png": 20439,
	"./shiny/404.png": 9185,
	"./shiny/405.png": 17850,
	"./shiny/406.png": 76001,
	"./shiny/407.png": 66788,
	"./shiny/408.png": 76622,
	"./shiny/409.png": 42857,
	"./shiny/41.png": 4448,
	"./shiny/410.png": 2666,
	"./shiny/411.png": 59052,
	"./shiny/412.png": 1444,
	"./shiny/413.png": 85315,
	"./shiny/414.png": 13967,
	"./shiny/415.png": 23767,
	"./shiny/416.png": 24385,
	"./shiny/417.png": 22123,
	"./shiny/418.png": 75388,
	"./shiny/419.png": 49760,
	"./shiny/42.png": 8275,
	"./shiny/420.png": 19880,
	"./shiny/421.png": 18956,
	"./shiny/422.png": 65505,
	"./shiny/423.png": 20844,
	"./shiny/424.png": 74122,
	"./shiny/425.png": 66371,
	"./shiny/426.png": 45415,
	"./shiny/427.png": 88565,
	"./shiny/428.png": 95947,
	"./shiny/429.png": 37849,
	"./shiny/43.png": 19496,
	"./shiny/430.png": 80609,
	"./shiny/431.png": 68776,
	"./shiny/432.png": 41022,
	"./shiny/433.png": 77281,
	"./shiny/434.png": 22106,
	"./shiny/435.png": 49612,
	"./shiny/436.png": 21646,
	"./shiny/437.png": 9018,
	"./shiny/438.png": 89424,
	"./shiny/439.png": 94691,
	"./shiny/44.png": 70744,
	"./shiny/440.png": 17055,
	"./shiny/441.png": 25368,
	"./shiny/442.png": 62756,
	"./shiny/443.png": 48872,
	"./shiny/444.png": 39898,
	"./shiny/445.png": 13082,
	"./shiny/446.png": 83897,
	"./shiny/447.png": 5457,
	"./shiny/448.png": 72009,
	"./shiny/449.png": 65648,
	"./shiny/45.png": 45020,
	"./shiny/450.png": 25143,
	"./shiny/451.png": 36242,
	"./shiny/452.png": 60547,
	"./shiny/453.png": 54669,
	"./shiny/454.png": 66578,
	"./shiny/455.png": 48114,
	"./shiny/456.png": 92954,
	"./shiny/457.png": 84987,
	"./shiny/458.png": 56932,
	"./shiny/459.png": 93194,
	"./shiny/46.png": 54434,
	"./shiny/460.png": 41149,
	"./shiny/461.png": 61707,
	"./shiny/462.png": 81273,
	"./shiny/463.png": 2040,
	"./shiny/464.png": 90605,
	"./shiny/465.png": 56490,
	"./shiny/466.png": 20630,
	"./shiny/467.png": 17455,
	"./shiny/468.png": 1018,
	"./shiny/469.png": 85154,
	"./shiny/47.png": 39701,
	"./shiny/470.png": 50814,
	"./shiny/471.png": 42119,
	"./shiny/472.png": 90374,
	"./shiny/473.png": 49285,
	"./shiny/474.png": 56141,
	"./shiny/475.png": 64578,
	"./shiny/476.png": 69431,
	"./shiny/477.png": 87937,
	"./shiny/478.png": 91901,
	"./shiny/479.png": 86954,
	"./shiny/48.png": 28556,
	"./shiny/480.png": 44557,
	"./shiny/481.png": 86778,
	"./shiny/482.png": 76079,
	"./shiny/483.png": 47515,
	"./shiny/484.png": 61786,
	"./shiny/485.png": 59170,
	"./shiny/486.png": 50818,
	"./shiny/487.png": 14744,
	"./shiny/488.png": 82998,
	"./shiny/489.png": 66113,
	"./shiny/49.png": 58646,
	"./shiny/490.png": 639,
	"./shiny/491.png": 14513,
	"./shiny/492.png": 602,
	"./shiny/493.png": 34998,
	"./shiny/494.png": 67581,
	"./shiny/495.png": 8646,
	"./shiny/496.png": 69745,
	"./shiny/497.png": 28836,
	"./shiny/498.png": 97110,
	"./shiny/499.png": 32335,
	"./shiny/5.png": 70566,
	"./shiny/50.png": 56767,
	"./shiny/500.png": 9869,
	"./shiny/501.png": 3387,
	"./shiny/502.png": 70972,
	"./shiny/503.png": 70010,
	"./shiny/504.png": 50526,
	"./shiny/505.png": 61722,
	"./shiny/506.png": 54851,
	"./shiny/507.png": 65893,
	"./shiny/508.png": 15321,
	"./shiny/509.png": 24005,
	"./shiny/51.png": 43581,
	"./shiny/510.png": 62797,
	"./shiny/511.png": 58421,
	"./shiny/512.png": 8394,
	"./shiny/513.png": 51004,
	"./shiny/514.png": 25261,
	"./shiny/515.png": 86884,
	"./shiny/516.png": 81138,
	"./shiny/517.png": 47965,
	"./shiny/518.png": 66067,
	"./shiny/519.png": 66560,
	"./shiny/52.png": 40035,
	"./shiny/520.png": 93367,
	"./shiny/521.png": 48780,
	"./shiny/522.png": 67971,
	"./shiny/523.png": 97765,
	"./shiny/524.png": 99824,
	"./shiny/525.png": 84642,
	"./shiny/526.png": 47593,
	"./shiny/527.png": 9047,
	"./shiny/528.png": 2067,
	"./shiny/529.png": 12395,
	"./shiny/53.png": 1842,
	"./shiny/530.png": 27368,
	"./shiny/531.png": 2793,
	"./shiny/532.png": 2631,
	"./shiny/533.png": 22432,
	"./shiny/534.png": 47238,
	"./shiny/535.png": 92828,
	"./shiny/536.png": 36630,
	"./shiny/537.png": 62033,
	"./shiny/538.png": 80897,
	"./shiny/539.png": 7720,
	"./shiny/54.png": 11442,
	"./shiny/540.png": 44627,
	"./shiny/541.png": 69801,
	"./shiny/542.png": 22396,
	"./shiny/543.png": 7298,
	"./shiny/544.png": 28213,
	"./shiny/545.png": 99125,
	"./shiny/546.png": 68982,
	"./shiny/547.png": 28797,
	"./shiny/548.png": 44975,
	"./shiny/549.png": 51366,
	"./shiny/55.png": 48141,
	"./shiny/550.png": 82980,
	"./shiny/551.png": 39151,
	"./shiny/552.png": 77937,
	"./shiny/553.png": 44551,
	"./shiny/554.png": 59178,
	"./shiny/555.png": 26066,
	"./shiny/556.png": 74475,
	"./shiny/557.png": 5246,
	"./shiny/558.png": 34295,
	"./shiny/559.png": 72040,
	"./shiny/56.png": 85277,
	"./shiny/560.png": 3537,
	"./shiny/561.png": 64909,
	"./shiny/562.png": 62223,
	"./shiny/563.png": 38718,
	"./shiny/564.png": 88214,
	"./shiny/565.png": 258,
	"./shiny/566.png": 84963,
	"./shiny/567.png": 58642,
	"./shiny/568.png": 17210,
	"./shiny/569.png": 98685,
	"./shiny/57.png": 78015,
	"./shiny/570.png": 95668,
	"./shiny/571.png": 56392,
	"./shiny/572.png": 79966,
	"./shiny/573.png": 50182,
	"./shiny/574.png": 73063,
	"./shiny/575.png": 58676,
	"./shiny/576.png": 93781,
	"./shiny/577.png": 17853,
	"./shiny/578.png": 89263,
	"./shiny/579.png": 39843,
	"./shiny/58.png": 91536,
	"./shiny/580.png": 2242,
	"./shiny/581.png": 51310,
	"./shiny/582.png": 64842,
	"./shiny/583.png": 63880,
	"./shiny/584.png": 30220,
	"./shiny/585.png": 83885,
	"./shiny/586.png": 18581,
	"./shiny/587.png": 52980,
	"./shiny/588.png": 86254,
	"./shiny/589.png": 93018,
	"./shiny/59.png": 7459,
	"./shiny/590.png": 65927,
	"./shiny/591.png": 26793,
	"./shiny/592.png": 9715,
	"./shiny/593.png": 94393,
	"./shiny/594.png": 81189,
	"./shiny/595.png": 21661,
	"./shiny/596.png": 20399,
	"./shiny/597.png": 24153,
	"./shiny/598.png": 13650,
	"./shiny/599.png": 93589,
	"./shiny/6.png": 29928,
	"./shiny/60.png": 1954,
	"./shiny/600.png": 97001,
	"./shiny/601.png": 37205,
	"./shiny/602.png": 76863,
	"./shiny/603.png": 9068,
	"./shiny/604.png": 67592,
	"./shiny/605.png": 3465,
	"./shiny/606.png": 50123,
	"./shiny/607.png": 31261,
	"./shiny/608.png": 74462,
	"./shiny/609.png": 36464,
	"./shiny/61.png": 82713,
	"./shiny/610.png": 24596,
	"./shiny/611.png": 54467,
	"./shiny/612.png": 57431,
	"./shiny/613.png": 54052,
	"./shiny/614.png": 50728,
	"./shiny/615.png": 9365,
	"./shiny/616.png": 21730,
	"./shiny/617.png": 46974,
	"./shiny/618.png": 87843,
	"./shiny/619.png": 99648,
	"./shiny/62.png": 81878,
	"./shiny/620.png": 73728,
	"./shiny/621.png": 44047,
	"./shiny/622.png": 38156,
	"./shiny/623.png": 25717,
	"./shiny/624.png": 45642,
	"./shiny/625.png": 45712,
	"./shiny/626.png": 89701,
	"./shiny/627.png": 37275,
	"./shiny/628.png": 20628,
	"./shiny/629.png": 93479,
	"./shiny/63.png": 5603,
	"./shiny/630.png": 84201,
	"./shiny/631.png": 38666,
	"./shiny/632.png": 36928,
	"./shiny/633.png": 91824,
	"./shiny/634.png": 8122,
	"./shiny/635.png": 39867,
	"./shiny/636.png": 93031,
	"./shiny/637.png": 42210,
	"./shiny/638.png": 36697,
	"./shiny/639.png": 70024,
	"./shiny/64.png": 61140,
	"./shiny/640.png": 33678,
	"./shiny/641.png": 34134,
	"./shiny/642.png": 59757,
	"./shiny/643.png": 28883,
	"./shiny/644.png": 32654,
	"./shiny/645.png": 3092,
	"./shiny/646.png": 73623,
	"./shiny/647.png": 80769,
	"./shiny/648.png": 29149,
	"./shiny/649.png": 33589,
	"./shiny/65.png": 79281,
	"./shiny/650.png": 53334,
	"./shiny/651.png": 11296,
	"./shiny/652.png": 84134,
	"./shiny/653.png": 80569,
	"./shiny/654.png": 76101,
	"./shiny/655.png": 60146,
	"./shiny/656.png": 61854,
	"./shiny/657.png": 92626,
	"./shiny/658.png": 94125,
	"./shiny/659.png": 72080,
	"./shiny/66.png": 66806,
	"./shiny/660.png": 76369,
	"./shiny/661.png": 899,
	"./shiny/662.png": 31934,
	"./shiny/663.png": 29154,
	"./shiny/664.png": 35753,
	"./shiny/665.png": 6369,
	"./shiny/666.png": 48116,
	"./shiny/667.png": 36104,
	"./shiny/668.png": 52696,
	"./shiny/669.png": 15996,
	"./shiny/67.png": 84380,
	"./shiny/670.png": 71389,
	"./shiny/671.png": 5942,
	"./shiny/672.png": 67500,
	"./shiny/673.png": 42920,
	"./shiny/674.png": 77539,
	"./shiny/675.png": 84955,
	"./shiny/676.png": 31086,
	"./shiny/677.png": 46226,
	"./shiny/678.png": 98922,
	"./shiny/679.png": 90357,
	"./shiny/68.png": 36454,
	"./shiny/680.png": 94280,
	"./shiny/681.png": 64708,
	"./shiny/682.png": 95173,
	"./shiny/683.png": 67553,
	"./shiny/684.png": 89092,
	"./shiny/685.png": 21304,
	"./shiny/686.png": 37588,
	"./shiny/687.png": 68593,
	"./shiny/688.png": 48658,
	"./shiny/689.png": 28013,
	"./shiny/69.png": 13106,
	"./shiny/690.png": 94583,
	"./shiny/691.png": 90833,
	"./shiny/692.png": 69451,
	"./shiny/693.png": 6338,
	"./shiny/694.png": 65052,
	"./shiny/695.png": 41843,
	"./shiny/696.png": 83632,
	"./shiny/697.png": 66690,
	"./shiny/698.png": 50936,
	"./shiny/699.png": 36319,
	"./shiny/7.png": 31107,
	"./shiny/70.png": 72322,
	"./shiny/700.png": 99596,
	"./shiny/701.png": 88329,
	"./shiny/702.png": 90594,
	"./shiny/703.png": 92350,
	"./shiny/704.png": 48081,
	"./shiny/705.png": 20041,
	"./shiny/706.png": 88253,
	"./shiny/707.png": 54028,
	"./shiny/708.png": 31976,
	"./shiny/709.png": 83736,
	"./shiny/71.png": 23094,
	"./shiny/710.png": 40661,
	"./shiny/711.png": 53990,
	"./shiny/712.png": 40478,
	"./shiny/713.png": 53940,
	"./shiny/714.png": 409,
	"./shiny/715.png": 88634,
	"./shiny/716.png": 19422,
	"./shiny/717.png": 75694,
	"./shiny/718.png": 75442,
	"./shiny/719.png": 19540,
	"./shiny/72.png": 30803,
	"./shiny/720.png": 85122,
	"./shiny/721.png": 99989,
	"./shiny/722.png": 56538,
	"./shiny/723.png": 14851,
	"./shiny/724.png": 9850,
	"./shiny/725.png": 91423,
	"./shiny/726.png": 3226,
	"./shiny/727.png": 45706,
	"./shiny/728.png": 87826,
	"./shiny/729.png": 14403,
	"./shiny/73.png": 73593,
	"./shiny/730.png": 40860,
	"./shiny/731.png": 10358,
	"./shiny/732.png": 21451,
	"./shiny/733.png": 33094,
	"./shiny/734.png": 91355,
	"./shiny/735.png": 99157,
	"./shiny/736.png": 9396,
	"./shiny/737.png": 76983,
	"./shiny/738.png": 12359,
	"./shiny/739.png": 71419,
	"./shiny/74.png": 24665,
	"./shiny/740.png": 48752,
	"./shiny/741.png": 81811,
	"./shiny/742.png": 75215,
	"./shiny/743.png": 55521,
	"./shiny/744.png": 53263,
	"./shiny/745.png": 1404,
	"./shiny/746.png": 61587,
	"./shiny/747.png": 87923,
	"./shiny/748.png": 54729,
	"./shiny/749.png": 45751,
	"./shiny/75.png": 83612,
	"./shiny/750.png": 42151,
	"./shiny/751.png": 81170,
	"./shiny/752.png": 55865,
	"./shiny/753.png": 50885,
	"./shiny/754.png": 34810,
	"./shiny/755.png": 80984,
	"./shiny/756.png": 29992,
	"./shiny/757.png": 98161,
	"./shiny/758.png": 14772,
	"./shiny/759.png": 43824,
	"./shiny/76.png": 84136,
	"./shiny/760.png": 12439,
	"./shiny/761.png": 84770,
	"./shiny/762.png": 95174,
	"./shiny/763.png": 88264,
	"./shiny/764.png": 40246,
	"./shiny/765.png": 24090,
	"./shiny/766.png": 88968,
	"./shiny/767.png": 30732,
	"./shiny/768.png": 92586,
	"./shiny/769.png": 37379,
	"./shiny/77.png": 78059,
	"./shiny/770.png": 97562,
	"./shiny/771.png": 43171,
	"./shiny/772.png": 90889,
	"./shiny/773.png": 33617,
	"./shiny/774.png": 12852,
	"./shiny/775.png": 1277,
	"./shiny/776.png": 88819,
	"./shiny/777.png": 81565,
	"./shiny/778.png": 26056,
	"./shiny/779.png": 10871,
	"./shiny/78.png": 99640,
	"./shiny/780.png": 39239,
	"./shiny/781.png": 10793,
	"./shiny/782.png": 22705,
	"./shiny/783.png": 71887,
	"./shiny/784.png": 83829,
	"./shiny/785.png": 87215,
	"./shiny/786.png": 51058,
	"./shiny/787.png": 15947,
	"./shiny/788.png": 95903,
	"./shiny/789.png": 11614,
	"./shiny/79.png": 32453,
	"./shiny/790.png": 84073,
	"./shiny/791.png": 12930,
	"./shiny/792.png": 46568,
	"./shiny/793.png": 28964,
	"./shiny/794.png": 34850,
	"./shiny/795.png": 31911,
	"./shiny/796.png": 48133,
	"./shiny/797.png": 99911,
	"./shiny/798.png": 90390,
	"./shiny/799.png": 59911,
	"./shiny/8.png": 55843,
	"./shiny/80.png": 4338,
	"./shiny/800.png": 6611,
	"./shiny/801.png": 81762,
	"./shiny/802.png": 19676,
	"./shiny/803.png": 35330,
	"./shiny/804.png": 30610,
	"./shiny/805.png": 4780,
	"./shiny/806.png": 39444,
	"./shiny/807.png": 29086,
	"./shiny/808.png": 63470,
	"./shiny/809.png": 92615,
	"./shiny/81.png": 21528,
	"./shiny/810.png": 23443,
	"./shiny/811.png": 43197,
	"./shiny/812.png": 66667,
	"./shiny/813.png": 6407,
	"./shiny/814.png": 87598,
	"./shiny/815.png": 31645,
	"./shiny/816.png": 80600,
	"./shiny/817.png": 54873,
	"./shiny/818.png": 45904,
	"./shiny/819.png": 86746,
	"./shiny/82.png": 53004,
	"./shiny/820.png": 90946,
	"./shiny/821.png": 31507,
	"./shiny/822.png": 692,
	"./shiny/823.png": 83846,
	"./shiny/824.png": 17755,
	"./shiny/825.png": 37925,
	"./shiny/826.png": 85587,
	"./shiny/827.png": 73585,
	"./shiny/828.png": 51470,
	"./shiny/829.png": 29904,
	"./shiny/83.png": 20525,
	"./shiny/830.png": 45696,
	"./shiny/831.png": 707,
	"./shiny/832.png": 97372,
	"./shiny/833.png": 1297,
	"./shiny/834.png": 67208,
	"./shiny/835.png": 52087,
	"./shiny/836.png": 80908,
	"./shiny/837.png": 10718,
	"./shiny/838.png": 63618,
	"./shiny/839.png": 52386,
	"./shiny/84.png": 53537,
	"./shiny/840.png": 42660,
	"./shiny/841.png": 45071,
	"./shiny/842.png": 17903,
	"./shiny/843.png": 34929,
	"./shiny/844.png": 64122,
	"./shiny/845.png": 75279,
	"./shiny/846.png": 28254,
	"./shiny/847.png": 21435,
	"./shiny/848.png": 76893,
	"./shiny/849.png": 34504,
	"./shiny/85.png": 4436,
	"./shiny/850.png": 59490,
	"./shiny/851.png": 17302,
	"./shiny/852.png": 47092,
	"./shiny/853.png": 36943,
	"./shiny/854.png": 53689,
	"./shiny/855.png": 85956,
	"./shiny/856.png": 75473,
	"./shiny/857.png": 19598,
	"./shiny/858.png": 82845,
	"./shiny/859.png": 23461,
	"./shiny/86.png": 83221,
	"./shiny/860.png": 22783,
	"./shiny/861.png": 66569,
	"./shiny/862.png": 85707,
	"./shiny/863.png": 79328,
	"./shiny/864.png": 56135,
	"./shiny/865.png": 63384,
	"./shiny/866.png": 55534,
	"./shiny/867.png": 44775,
	"./shiny/868.png": 18813,
	"./shiny/869.png": 76932,
	"./shiny/87.png": 28420,
	"./shiny/870.png": 99121,
	"./shiny/871.png": 37715,
	"./shiny/872.png": 5617,
	"./shiny/873.png": 91404,
	"./shiny/874.png": 68058,
	"./shiny/875.png": 58467,
	"./shiny/876.png": 53505,
	"./shiny/878.png": 48781,
	"./shiny/879.png": 36198,
	"./shiny/88.png": 51735,
	"./shiny/880.png": 56508,
	"./shiny/881.png": 83236,
	"./shiny/882.png": 80966,
	"./shiny/883.png": 43860,
	"./shiny/884.png": 64686,
	"./shiny/885.png": 65155,
	"./shiny/886.png": 67871,
	"./shiny/887.png": 24728,
	"./shiny/888.png": 50803,
	"./shiny/889.png": 92898,
	"./shiny/89.png": 31135,
	"./shiny/890.png": 42768,
	"./shiny/891.png": 39920,
	"./shiny/892.png": 46470,
	"./shiny/893.png": 75454,
	"./shiny/894.png": 62824,
	"./shiny/895.png": 30387,
	"./shiny/896.png": 46941,
	"./shiny/897.png": 41512,
	"./shiny/898.png": 24535,
	"./shiny/899.png": 71628,
	"./shiny/9.png": 19735,
	"./shiny/90.png": 62743,
	"./shiny/900.png": 748,
	"./shiny/901.png": 35243,
	"./shiny/902.png": 95167,
	"./shiny/903.png": 80579,
	"./shiny/904.png": 77312,
	"./shiny/905.png": 49781,
	"./shiny/906.png": 16623,
	"./shiny/907.png": 83550,
	"./shiny/908.png": 83932,
	"./shiny/909.png": 48866,
	"./shiny/91.png": 47503,
	"./shiny/910.png": 61304,
	"./shiny/911.png": 44855,
	"./shiny/912.png": 16423,
	"./shiny/913.png": 57933,
	"./shiny/914.png": 80313,
	"./shiny/915.png": 30389,
	"./shiny/916.png": 99660,
	"./shiny/917.png": 11359,
	"./shiny/918.png": 66341,
	"./shiny/919.png": 49597,
	"./shiny/92.png": 90966,
	"./shiny/920.png": 81882,
	"./shiny/921.png": 67362,
	"./shiny/922.png": 69014,
	"./shiny/923.png": 2181,
	"./shiny/924.png": 52037,
	"./shiny/925.png": 42669,
	"./shiny/926.png": 33761,
	"./shiny/927.png": 419,
	"./shiny/928.png": 79377,
	"./shiny/929.png": 29199,
	"./shiny/93.png": 80846,
	"./shiny/930.png": 91529,
	"./shiny/931.png": 31190,
	"./shiny/932.png": 61470,
	"./shiny/933.png": 71284,
	"./shiny/934.png": 7314,
	"./shiny/935.png": 25009,
	"./shiny/936.png": 631,
	"./shiny/937.png": 27825,
	"./shiny/938.png": 94910,
	"./shiny/939.png": 28440,
	"./shiny/94.png": 62780,
	"./shiny/940.png": 95484,
	"./shiny/941.png": 97999,
	"./shiny/942.png": 34762,
	"./shiny/943.png": 14821,
	"./shiny/944.png": 38371,
	"./shiny/945.png": 61510,
	"./shiny/946.png": 22875,
	"./shiny/947.png": 64601,
	"./shiny/948.png": 10013,
	"./shiny/949.png": 79144,
	"./shiny/95.png": 58148,
	"./shiny/950.png": 39548,
	"./shiny/951.png": 141,
	"./shiny/952.png": 51811,
	"./shiny/953.png": 5182,
	"./shiny/954.png": 18507,
	"./shiny/955.png": 4432,
	"./shiny/956.png": 99802,
	"./shiny/957.png": 3955,
	"./shiny/958.png": 99833,
	"./shiny/959.png": 28874,
	"./shiny/96.png": 78824,
	"./shiny/960.png": 97137,
	"./shiny/961.png": 65814,
	"./shiny/962.png": 63802,
	"./shiny/963.png": 59392,
	"./shiny/964.png": 47873,
	"./shiny/965.png": 76258,
	"./shiny/966.png": 80119,
	"./shiny/967.png": 82888,
	"./shiny/968.png": 6771,
	"./shiny/969.png": 23407,
	"./shiny/97.png": 87505,
	"./shiny/970.png": 99251,
	"./shiny/971.png": 79904,
	"./shiny/972.png": 10623,
	"./shiny/973.png": 10417,
	"./shiny/974.png": 49952,
	"./shiny/975.png": 11741,
	"./shiny/976.png": 29849,
	"./shiny/977.png": 70561,
	"./shiny/978.png": 38609,
	"./shiny/979.png": 79045,
	"./shiny/98.png": 61237,
	"./shiny/980.png": 51195,
	"./shiny/981.png": 46654,
	"./shiny/982.png": 92408,
	"./shiny/983.png": 27647,
	"./shiny/984.png": 56469,
	"./shiny/985.png": 92359,
	"./shiny/986.png": 76705,
	"./shiny/987.png": 24939,
	"./shiny/988.png": 55066,
	"./shiny/989.png": 3178,
	"./shiny/99.png": 20723,
	"./shiny/990.png": 14361,
	"./shiny/991.png": 54,
	"./shiny/992.png": 44707,
	"./shiny/993.png": 426,
	"./shiny/994.png": 94884,
	"./shiny/995.png": 6195,
	"./shiny/996.png": 82231,
	"./shiny/997.png": 70291,
	"./shiny/998.png": 87106,
	"./shiny/999.png": 28696,
	"./shroodle.png": 21579,
	"./shroomish.png": 80483,
	"./shuckle.png": 95404,
	"./shuppet.png": 24627,
	"./sigilyph.png": 61815,
	"./silcoon.png": 47464,
	"./silicobra.png": 16264,
	"./silvally.png": 3175,
	"./simipour.png": 13088,
	"./simisage.png": 41624,
	"./simisear.png": 21043,
	"./sinistea.png": 16573,
	"./sirfetchd.png": 83955,
	"./sizzlipede.png": 47612,
	"./skarmory.png": 39254,
	"./skeledirge.png": 33606,
	"./skiddo.png": 77266,
	"./skiploom.png": 13769,
	"./skitty.png": 76938,
	"./skorupi.png": 49714,
	"./skrelp.png": 92399,
	"./skuntank.png": 51787,
	"./skwovet.png": 12377,
	"./slaking.png": 39333,
	"./slakoth.png": 52957,
	"./sliggoo-hisui.png": 26129,
	"./sliggoo.png": 68101,
	"./slither-wing.png": 33528,
	"./slowbro-galar.png": 6276,
	"./slowbro-mega.png": 8350,
	"./slowbro.png": 41168,
	"./slowking-galar.png": 38900,
	"./slowking.png": 44383,
	"./slowpoke-galar.png": 17164,
	"./slowpoke.png": 94129,
	"./slugma.png": 85853,
	"./slurpuff.png": 3495,
	"./smeargle.png": 46602,
	"./smoliv.png": 43094,
	"./smoochum.png": 39694,
	"./sneasel-hisui.png": 63646,
	"./sneasel.png": 88779,
	"./sneasler.png": 70836,
	"./snivy.png": 85312,
	"./snom.png": 68866,
	"./snorlax-gmax.png": 20497,
	"./snorlax.png": 76376,
	"./snorunt.png": 16913,
	"./snover.png": 46817,
	"./snubbull.png": 335,
	"./sobble.png": 22556,
	"./solgaleo.png": 79419,
	"./solosis.png": 68462,
	"./solrock.png": 11237,
	"./spearow.png": 61858,
	"./spectrier.png": 3775,
	"./spewpa.png": 31897,
	"./spheal.png": 85090,
	"./spidops.png": 79566,
	"./spinarak.png": 76636,
	"./spinda.png": 24204,
	"./spiritomb.png": 71630,
	"./spoink.png": 7941,
	"./sprigatito.png": 30853,
	"./spritzee.png": 54517,
	"./squawkabilly-blue-plumage.png": 43782,
	"./squawkabilly-white-plumage.png": 68630,
	"./squawkabilly-yellow-plumage.png": 93302,
	"./squawkabilly.png": 69076,
	"./squirtle.png": 21737,
	"./stakataka.png": 26916,
	"./stantler.png": 47116,
	"./staraptor.png": 54319,
	"./staravia.png": 66543,
	"./starly.png": 58134,
	"./starmie.png": 73863,
	"./staryu.png": 47294,
	"./steelix-mega.png": 75171,
	"./steelix.png": 47228,
	"./steenee.png": 51914,
	"./stonjourner.png": 86307,
	"./stoutland.png": 56194,
	"./stufful.png": 35026,
	"./stunfisk-galar.png": 36272,
	"./stunfisk.png": 49969,
	"./stunky.png": 48185,
	"./sudowoodo.png": 92356,
	"./suicune.png": 34593,
	"./sunflora.png": 93144,
	"./sunkern.png": 78737,
	"./surskit.png": 91677,
	"./swablu.png": 26030,
	"./swadloon.png": 56011,
	"./swalot.png": 42581,
	"./swampert-mega.png": 16058,
	"./swampert.png": 87535,
	"./swanna.png": 22889,
	"./swellow.png": 15239,
	"./swinub.png": 47083,
	"./swirlix.png": 47843,
	"./swoobat.png": 76683,
	"./sylveon.png": 42386,
	"./tadbulb.png": 48645,
	"./taillow.png": 59092,
	"./talonflame.png": 88397,
	"./tandemaus.png": 72563,
	"./tangela.png": 85374,
	"./tangrowth.png": 403,
	"./tapu-bulu.png": 89505,
	"./tapu-fini.png": 91463,
	"./tapu-koko.png": 62838,
	"./tapu-lele.png": 98467,
	"./tarountula.png": 72984,
	"./tatsugiri-droopy.png": 94510,
	"./tatsugiri-stretchy.png": 57093,
	"./tatsugiri.png": 94452,
	"./tauros-paldea-aqua-breed.png": 53191,
	"./tauros-paldea-blaze-breed.png": 57110,
	"./tauros-paldea-combat-breed.png": 74576,
	"./tauros.png": 22264,
	"./teddiursa.png": 76277,
	"./tentacool.png": 67504,
	"./tentacruel.png": 57455,
	"./tepig.png": 35131,
	"./terrakion.png": 97209,
	"./thievul.png": 51151,
	"./throh.png": 1848,
	"./thundurus-incarnate.png": 4511,
	"./thundurus-therian.png": 69223,
	"./thwackey.png": 84142,
	"./timburr.png": 89457,
	"./ting-lu.png": 16880,
	"./tinkatink.png": 51068,
	"./tinkaton.png": 92883,
	"./tinkatuff.png": 83586,
	"./tirtouga.png": 95253,
	"./toedscool.png": 7577,
	"./toedscruel.png": 72723,
	"./togedemaru-totem.png": 20220,
	"./togedemaru.png": 18622,
	"./togekiss.png": 70350,
	"./togepi.png": 31495,
	"./togetic.png": 27899,
	"./torchic.png": 36423,
	"./torkoal.png": 57162,
	"./tornadus-incarnate.png": 61892,
	"./tornadus-therian.png": 4277,
	"./torracat.png": 56274,
	"./torterra.png": 99145,
	"./totodile.png": 46962,
	"./toucannon.png": 13180,
	"./toxapex.png": 2924,
	"./toxel.png": 14734,
	"./toxicroak.png": 58050,
	"./toxtricity-amped-gmax.png": 47623,
	"./toxtricity-amped.png": 9032,
	"./toxtricity-low-key-gmax.png": 23766,
	"./toxtricity-low-key.png": 25470,
	"./tranquill.png": 29207,
	"./trapinch.png": 75597,
	"./treecko.png": 64761,
	"./trevenant.png": 29804,
	"./tropius.png": 63458,
	"./trubbish.png": 42681,
	"./trumbeak.png": 7152,
	"./tsareena.png": 84015,
	"./turtonator.png": 12331,
	"./turtwig.png": 55701,
	"./tympole.png": 18961,
	"./tynamo.png": 31641,
	"./type-null.png": 10586,
	"./typhlosion-hisui.png": 89059,
	"./typhlosion.png": 59968,
	"./tyranitar-mega.png": 59969,
	"./tyranitar.png": 50501,
	"./tyrantrum.png": 35741,
	"./tyrogue.png": 78202,
	"./tyrunt.png": 54181,
	"./umbreon.png": 42203,
	"./unfezant.png": 78289,
	"./unown.png": 46012,
	"./ursaluna.png": 64500,
	"./ursaring.png": 92506,
	"./urshifu-rapid-strike-gmax.png": 96948,
	"./urshifu-rapid-strike.png": 65040,
	"./urshifu-single-strike-gmax.png": 88623,
	"./urshifu-single-strike.png": 59256,
	"./uxie.png": 88929,
	"./vanillish.png": 21497,
	"./vanillite.png": 22054,
	"./vanilluxe.png": 29687,
	"./vaporeon.png": 73068,
	"./varoom.png": 50595,
	"./veluza.png": 61260,
	"./venipede.png": 38009,
	"./venomoth.png": 89991,
	"./venonat.png": 38656,
	"./venusaur-gmax.png": 5277,
	"./venusaur-mega.png": 40086,
	"./venusaur.png": 72574,
	"./vespiquen.png": 55579,
	"./vibrava.png": 12225,
	"./victini.png": 87065,
	"./victreebel.png": 98848,
	"./vigoroth.png": 1262,
	"./vikavolt-totem.png": 31244,
	"./vikavolt.png": 36516,
	"./vileplume.png": 77972,
	"./virizion.png": 94756,
	"./vivillon.png": 77138,
	"./volbeat.png": 5438,
	"./volcanion.png": 39571,
	"./volcarona.png": 39543,
	"./voltorb-hisui.png": 72999,
	"./voltorb.png": 59354,
	"./vullaby.png": 12094,
	"./vulpix-alola.png": 19868,
	"./vulpix.png": 79574,
	"./wailmer.png": 81819,
	"./wailord.png": 7295,
	"./walking-wake.png": 22916,
	"./walrein.png": 42438,
	"./wartortle.png": 91392,
	"./watchog.png": 84533,
	"./wattrel.png": 19306,
	"./weavile.png": 46220,
	"./weedle.png": 62500,
	"./weepinbell.png": 51457,
	"./weezing-galar.png": 6595,
	"./weezing.png": 33373,
	"./whimsicott.png": 51474,
	"./whirlipede.png": 50099,
	"./whiscash.png": 21273,
	"./whismur.png": 62951,
	"./wigglytuff.png": 31651,
	"./wiglett.png": 17827,
	"./wimpod.png": 96438,
	"./wingull.png": 33426,
	"./wishiwashi-school.png": 95260,
	"./wishiwashi-solo.png": 50635,
	"./wo-chien.png": 7933,
	"./wobbuffet.png": 34751,
	"./woobat.png": 5442,
	"./wooloo.png": 95827,
	"./wooper-paldea.png": 93494,
	"./wooper.png": 66403,
	"./wormadam-plant.png": 23199,
	"./wormadam-sandy.png": 14234,
	"./wormadam-trash.png": 14398,
	"./wugtrio.png": 77288,
	"./wurmple.png": 87841,
	"./wynaut.png": 46631,
	"./wyrdeer.png": 41433,
	"./xatu.png": 30089,
	"./xerneas.png": 10004,
	"./xurkitree.png": 87571,
	"./yamask-galar.png": 54570,
	"./yamask.png": 13438,
	"./yamper.png": 72605,
	"./yanma.png": 14092,
	"./yanmega.png": 78692,
	"./yungoos.png": 68414,
	"./yveltal.png": 1142,
	"./zacian-crowned.png": 85588,
	"./zacian.png": 56196,
	"./zamazenta-crowned.png": 56888,
	"./zamazenta.png": 43906,
	"./zangoose.png": 66081,
	"./zapdos-galar.png": 97034,
	"./zapdos.png": 8089,
	"./zarude-dada.png": 71359,
	"./zarude.png": 86295,
	"./zebstrika.png": 91205,
	"./zekrom.png": 6066,
	"./zeraora.png": 36855,
	"./zigzagoon-galar.png": 20350,
	"./zigzagoon.png": 79750,
	"./zoroark-hisui.png": 89785,
	"./zoroark.png": 2309,
	"./zorua-hisui.png": 50364,
	"./zorua.png": 93959,
	"./zubat.png": 73282,
	"./zweilous.png": 8470,
	"./zygarde-10-power-construct.png": 16052,
	"./zygarde-10.png": 24617,
	"./zygarde-50-power-construct.png": 45598,
	"./zygarde-50.png": 21352,
	"./zygarde-complete.png": 22654
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39975;